<template>
  <pf-grid gutter>
    <wizard-summary-option
      v-if="wizard.domainRequired"
      :name="$t('Nome a Dominio')"
      :value="wizard.nomeDominio"
      :edit-step="wizard.askDomainFirst ? 'WizardStepDominio' : 'WizardStepAddon'"
      ouia-id="wizard-summary-dominio-nome"
    />

    <template v-if="wizard.path !== 'dominio' && (wizard.askDomainFirst || wizard.askDomainAddon)">
      <wizard-summary-option
        :name="$t('Registrazione Dominio')"
        :value="wizard.siNo(wizard.attivaDominio && !wizard.sottodominio)"
        :edit-step="wizard.askDomainFirst ? 'WizardStepDominio' : 'WizardStepAddon'"
        ouia-id="wizard-summary-dominio-registrazione"
      />
    </template>

    <wizard-summary-option
      v-if="wizard.askDomainFirst && wizard.domainRegistrationRequired"
      :name="$t('Attivazione Registrazione Premium')"
      :value="wizard.siNo(wizard.registrazionePremium)"
      :edit-step="wizard.askDomainFirst ? 'WizardStepDominio' : 'WizardStepAddon'"
      ouia-id="wizard-summary-dominio-premium"
    />
  </pf-grid>

  <pf-grid gutter>
    <wizard-summary-option
      v-if="wizard.path && ['hosting', 'mail'].includes(wizard.path)"
      :name="$t('Prodotto')"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-infrastruttura-prodotto"
    >
      <strong>{{ wizard.sceltaProdottoInfrastruttura }}</strong>
    </wizard-summary-option>

    <wizard-summary-option
      v-if="wizard.path === 'hosting' && wizard.configurazione"
      :name="$t('Configurazione')"
      edit-step="WizardStepConfigurazione"
      ouia-id="wizard-summary-infrastruttura-tecnologie"
    >
      <strong>{{ $t('Personalizzata') }}</strong>
      {{ ' ' }}
      <form-help-tooltip :text="wizard.configurazione" />
    </wizard-summary-option>

    <template v-if="wizard.askMailAddon">
      <wizard-summary-option
        v-if="wizard.path !== 'mail' && !wizard.mailAddon"
        :name="$t('Servizio mail')"
        :value="$t('Non richiesto')"
        edit-step="WizardStepAddon"
        ouia-id="wizard-summary-mail-attivazione"
      />

      <wizard-summary-option
        v-else-if="wizard.mailAddon && wizard.codiceProdottoMail"
        :name="$t('Prodotto mail')"
        :value="wizard.codiceProdottoMail"
        edit-step="WizardStepAddon"
        ouia-id="wizard-summary-mail-prodotto"
      />
    </template>

    <wizard-summary-location v-if="wizard.askRegion" :hide-backup="!['hosting', 'staging'].includes(wizard.path ?? '')" />
  </pf-grid>

  <pf-grid gutter v-if="wizard.os === 'linux' && (wizard.askSiteTransfer || wizard.askMailTransfer)">
    <wizard-summary-transfer />
  </pf-grid>

  <pf-grid gutter v-if="wizard.askSsl">
    <wizard-summary-option
      v-if="wizard.askSsl || wizard.askAddonSla"
      :name="$t('Certificato SSL')"
      :value="wizard.codiceSsl ? wizard.codiceSsl : $t('Let\'s Encrypt')"
      edit-step="WizardStepAddon"
      ouia-id="wizard-summary-addon-ssl"
    />

    <wizard-summary-option
      v-if="wizard.askAddonSla"
      :name="$t('Assistenza Premium')"
      :value="wizard.siNo(wizard.addonSla)"
      edit-step="WizardStepAddon"
      ouia-id="wizard-summary-addon-sla"
    />
  </pf-grid>
</template>

<script lang="ts" setup>
import WizardSummaryOption from './wizard-summary-option.vue';
import WizardSummaryLocation from './wizard-summary-location.vue';
import WizardSummaryTransfer from './wizard-summary-transfer.vue';
import FormHelpTooltip from '@/components/FormHelpTooltip.vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();
</script>
